<template>
  <div class="header flex flex-row">
    <div class="h-Qrcode basis-1/4">
      <img src="@/assets/icons/appbar_qrcode.svg" />
    </div>
    <h2 class="subject basis-1/2">{{ title }}</h2>
    <div
      class="basis-1/4"
      :class="[{ hmenut: dontHasHeader }, { hmenu: !dontHasHeader }]"
    >
      <img @click="showMenuHandler" src="@/assets/icons/appbar_menu.svg" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
  },
  computed: {
    dontHasHeader() {
      if (this.title == null) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    showMenuHandler() {
      this.$emit("showMenu");
    },
  },
};
</script>

<style></style>
